import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ChartService } from '../services/chart.service';
import { Observable } from 'rxjs';
import { map, tap, take, retryWhen } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  userEmail = ''; // 2AS

  constructor(private service: ChartService, private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.service.currentUserObservable.pipe(
      take(1),
      map((user: any) => {
        if (user != null) {
          this.userEmail = user.email;
        }
        return !!user;
      }),
      tap(loggedIn => {
        // console.log("logedIn :"+loggedIn);
        this.service.getAllKey().then(keyArray => {
          for (const key of keyArray) {
            if (key === this.service.getId()) {
              return;
            }
          }

          // 2AS allow fictive device ESP2635206COPY
          if (this.userEmail === '2as-control@gmail.com' || this.userEmail === '2as.smartlogger@gmail.com') {
            if (this.service.getId() === 'ESP2635206COPY') {
              return;
            }
          }

          // console.log('Stop!! not allowed to see that device!');
          this.router.navigate(['/home']);
        });
        if (!loggedIn) {
          // console.log("Stop!! auth guard!");
          this.router.navigate(['/login']);
        }
      })
    );
  }
}
